/* eslint-disable camelcase */
import React from "react"
import { auditShape } from "utils/propTypeShapes"
import TaskLink from "../TaskLink"

// There's no unique audit action for a task being closed, reopened,
// discarded, or recovered.  All of these use the same "update" action.
// To determine what type of change occurred, we must
// investigate the audited changes.
const changeDescription = (audit) => {
  const { auditedChanges } = audit
  const { closed_at = [], discarded_at = [] } = auditedChanges

  const taskClosed = Boolean(!closed_at[0] && closed_at[1])
  const taskReopened = Boolean(closed_at[0] && !closed_at[1])
  const taskDiscarded = Boolean(!discarded_at[0] && discarded_at[1])
  const taskRecovered = Boolean(discarded_at[0] && !discarded_at[1])

  let updateDescription = "Modified"

  if (taskClosed) {
    updateDescription = "Completed"
  } else if (taskReopened) {
    updateDescription = "Reopened"
  } else if (taskDiscarded) {
    updateDescription = "Deleted"
  } else if (taskRecovered) {
    updateDescription = "Recovered"
  }

  return updateDescription
}

const TaskUpdatedAuditItemDetails = ({ audit }) => {
  const { formSubmissionSlug, task } = audit

  return (
    <div>
      {changeDescription(audit)} <TaskLink task={task} formSubmissionSlug={formSubmissionSlug} />.
    </div>
  )
}

TaskUpdatedAuditItemDetails.propTypes = {
  audit: auditShape.isRequired,
}

export default TaskUpdatedAuditItemDetails
